import React, { useState } from 'react';
import { Heart } from 'lucide-react';

const EnvelopeIntro = ({ onOpened }) => {
  const [isOpening, setIsOpening] = useState(false);
  const [isFading, setIsFading] = useState(false);

  const handleOpen = () => {
    if (isOpening) return;
    setIsOpening(true);

    setTimeout(() => {
      setIsFading(true);
      setTimeout(() => {
        onOpened();
      }, 450);
    }, 700);
  };

  return (
    <div
      className={`min-h-screen w-full bg-[#FFDAE9] flex items-center justify-center transition-all duration-500 ${
        isFading ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
      }`}
    >
      <button
        onClick={handleOpen}
        className={`relative w-[240px] h-[170px] md:w-[320px] md:h-[230px] rounded-md border border-[#d4c4a8] bg-[#f5e6d3] shadow-lg cursor-pointer transition-all duration-300 ${
          isOpening ? 'pointer-events-none' : 'hover:scale-105 hover:shadow-xl'
        }`}
        aria-label="Open envelope"
      >
        <div
          className="absolute top-0 left-0 w-full h-full [clip-path:polygon(0_0,50%_50%,100%_0)] origin-top transition-transform duration-700 bg-gradient-to-br from-[#e8d5c4] via-[#d4c4a8] to-[#c9b89a]"
          style={{ transform: isOpening ? 'rotateX(-170deg)' : 'rotateX(0deg)' }}
        />
        <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${isOpening ? 'opacity-0' : 'opacity-100'}`}>
          <Heart size={56} className="text-[#c41e3a]" fill="currentColor" />
        </div>
      </button>
    </div>
  );
};

export default EnvelopeIntro;
